import createClient from "openapi-react-query"

import { createApiClient } from "@/api/utils"
import { env } from "@/env"
import type { paths as notificationsPaths } from "@/types/api/notifications/schema.gen"

const client = createApiClient<notificationsPaths>({ baseUrl: env.VITE_API2_URL })

// Vanilla API client
export const $notificationsApiClient = client.vanillaClient

// React-Query client
export const $rqNotificationsApiClient = createClient(client.rqClient)
